/**
 * <pmr-announcement-bar> — rotation des messages sur mobile uniquement.
 */
class PmrAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.pmr-announce__item')];
    this.index = 0;
    this.mobile = window.matchMedia('(max-width: 989px)');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const pause = () => this.stop();
    const resume = () => this.start();
    this.addEventListener('mouseenter', pause);
    this.addEventListener('mouseleave', resume);
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', resume);
    this.mobile.addEventListener('change', resume);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    if (!this.mobile.matches || this.reduced.matches || this.items.length < 2) return;
    const delay = Number(this.dataset.speed || 5) * 1000;
    this.timer = setInterval(() => this.next(), delay);
  }

  stop() {
    clearInterval(this.timer);
  }

  next() {
    this.items[this.index].classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }
}

if (!customElements.get('pmr-announcement-bar')) {
  customElements.define('pmr-announcement-bar', PmrAnnouncementBar);
}
